export class TenantPricingService{constructor(apiService){this.apiService=void 0;this.apiService=apiService;}// Get pricing sections for a tenant
async getTenantPricing(tenantId){// Keep the original API path for backward compatibility
return this.apiService.get(`/api/organizations/${tenantId}/pricing`);}}